import { Clock } from "lucide-react";

// Phase 4j portal-polish — surfaces an actionable "Pickup in 7 days"
// chip on portal cards. Three tones:
//   - upcoming (days >= 2): flag-navy text — passive informational
//   - due      (days == 0 or 1): amber — needs attention today/tomorrow
//   - overdue  (days < 0): brand-red — past due, escalate
type Tone = "upcoming" | "due" | "overdue";

const TONE_CLASS: Record<Tone, string> = {
  upcoming: "bg-flag-navy/5 text-flag-navy",
  due: "bg-amber-50 text-amber-900",
  overdue: "bg-brand-red/10 text-brand-red"
};

function pickTone(days: number): Tone {
  if (days < 0) return "overdue";
  if (days <= 1) return "due";
  return "upcoming";
}

function describe(label: string, days: number): string {
  if (days === 0) return `${label} today`;
  if (days === 1) return `${label} tomorrow`;
  if (days > 1) return `${label} in ${days} days`;
  const ago = Math.abs(days);
  return `${label} ${ago} day${ago === 1 ? "" : "s"} ago`;
}

export function CountdownChip({
  label,
  days
}: {
  label: string;
  days: number | null;
}): JSX.Element | null {
  if (days == null) return null;
  const tone = pickTone(days);
  return (
    <span
      data-testid="countdown-chip"
      data-tone={tone}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${TONE_CLASS[tone]}`}
    >
      <Clock aria-hidden="true" className="h-3 w-3" />
      {describe(label, days)}
    </span>
  );
}
